import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Input, Select } from "../../../../../../_metronic/_partials/controls";
import * as BranchReq from "../../../_redux/branchs/branchCrud";
import * as BankReq from "../../../_redux/bank/bankCrud";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Tooltip, IconButton, Typography } from "@material-ui/core";
import HelpIcon from "@material-ui/icons/Help";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import {
  BlockOrg,
  RoleChecker,
  RoleCheckerNoRedux
} from "../../../../../RoleChecker";
import { copyValue } from "../../../../../../_metronic/_helpers/UtilityHelpers";
import { roleExplanation } from "../../../../../../app/config/helper";

// Validation schema
const AccessRoleEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Nama Access Role Wajib Diisi")
});

export function AccessRoleEditForm({
  saveAccessRole,
  actionsLoading,
  accessRole,
  roleMaster,
  onHide,
  id
}) {
  const [role, setRole] = useState([]);
  const [roleForEdit, setRoleForEdit] = useState([]);

  const [access, setAccess] = useState([]);

  useEffect(() => {
    if (accessRole && accessRole.access) {
      setAccess(accessRole.access);
    }
  }, [accessRole]);

  const handleChangeAccessRole = value => event => {
    if (event.target.checked === true) {
      let findDuplicate = access.findIndex(
        element =>
          element.subject === value.subject && element.action === value.action
      );
      if (findDuplicate <= 0) {
        setAccess([...access, value]);
      }
    } else {
      let findDuplicate = access.findIndex(
        element =>
          element.subject === value.subject && element.action === value.action
      );
      let newAccess = [...access];
      newAccess.splice(findDuplicate, 1);
      setAccess(newAccess);
    }
  };

  const checkedAccessRoleFuction = value => {
    let checked = access.find(
      element =>
        element.action === value.action && element.subject === value.subject
    );
    if (checked) return true;
    else return false;
  };

  // const updateEditRole = (event, value) => {
  //     // const newList = [...newRoleForEdit]
  //     // newList.push(role)
  //     // const filteredList = newList.filter((v, i, a) => a.findIndex(t => (t.uuid === v.uuid)) === i)
  //     // setRoleForEdit(newList)

  //     if (event.target.checked === true) {
  //         let findDuplicate = roleForEdit.findIndex(
  //             (element) =>
  //                 element.subject === value.subject && element.action === value.action
  //         );
  //         if (findDuplicate <= 0) {
  //             setRoleForEdit([...roleForEdit, value]);
  //         }
  //     } else {
  //         let findDuplicate = roleForEdit.findIndex(
  //             (element) =>
  //                 element.subject === value.subject && element.action === value.action
  //         );
  //         let newRoleForEdit = [...roleForEdit];
  //         newRoleForEdit.splice(findDuplicate, 1);
  //         setRoleForEdit(newRoleForEdit);
  //     }
  // }

  // useEffect(() => {
  //     setRoleForEdit(accessRole.access)
  //     setRole([])
  //     if (id) {
  //         accessRole.access.length > 0 && createForm()
  //     } else {
  //         createForm()

  //     }

  // }, [roleMaster, accessRole])

  const accessRoleFunction = () => {
    const addRole = [];
    for (const key in roleMaster) {
      addRole.push(
        <div>
          <CardHeaderToolbar>
            <hr />
            <h5>
              {key
                .replace(/_/g, " ")
                .replace(/(\w)(\w*)/g, function(g0, g1, g2) {
                  return g1.toUpperCase() + g2.toLowerCase();
                })}
            </h5>
          </CardHeaderToolbar>
          <div className="row">
            {roleMaster[key].map(item => {
              return (
                <div className="col-md-3 mt-0 align-items-center">
                  <FormControlLabel
                    value="top"
                    control={
                      <Checkbox
                        checked={checkedAccessRoleFuction(item)}
                        onChange={handleChangeAccessRole(item)}
                      />
                    }
                    // control={<Checkbox checked={true} />}
                    label={item.action}
                    labelPlacement="end"
                    // onChange={(e) => {
                    //     // console.log(newRoleForEdit);
                    // }}
                  />
                  <Tooltip
                    title={
                      <Typography variant="body1">
                        {/*  find explanation on roleExplanation where subject = item.subject and item=item.action if exist use that data if dont "no explanation" */}
                        {roleExplanation.find(
                          element =>
                            element.subject === item.subject &&
                            element.action === item.action
                        )
                          ? roleExplanation.find(
                              element =>
                                element.subject === item.subject &&
                                element.action === item.action
                            ).explanation
                          : "No Explanation"}
                      </Typography>
                    }
                    placement="top"
                  >
                    <IconButton size="small">
                      <HelpIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    return addRole;
  };
  // const createForm = () => {
  //     // console.log('masuk');
  //     // console.log(accessRole);
  //     const newRoleForEdit = [...roleForEdit]
  //     const addRole = []
  //     for (const key in roleMaster) {
  //         addRole.push(
  //             <div>
  //                 <CardHeaderToolbar>
  //                     <hr />
  //                     <h5>{key.replace(/_/g, ' ').replace(/(\w)(\w*)/g,
  //                         function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); })}</h5>
  //                 </CardHeaderToolbar>
  //                 <div className="row">
  //                     {roleMaster[key].map((item) => {
  //                         return <div className="col-md-3 mt-0">
  //                             <FormControlLabel
  //                                 value='top'
  //                                 control={
  //                                     <Checkbox
  //                                         defaultChecked={RoleCheckerNoRedux(item.action, item.subject, accessRole.access)}
  //                                         onChange={handleChangeAccessRole(item)} />}
  //                                 // control={<Checkbox checked={true} />}
  //                                 label={item.action}
  //                                 labelPlacement="end"
  //                             // onChange={(e) => {
  //                             //     // console.log(newRoleForEdit);
  //                             // }}
  //                             />
  //                         </div>
  //                     })}
  //                 </div>
  //             </div>
  //         )

  //     }
  //     setRole(addRole)

  //     return addRole
  // }

  // console.log(roleForEdit)
  // console.log(access);

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={accessRole}
        validationSchema={AccessRoleEditSchema}
        onSubmit={values => {
          let newValue = copyValue(values);
          newValue.access = access;
          saveAccessRole(newValue);
        }}
      >
        {({ handleSubmit }) => (
          <>
            <Modal.Body className="overlay overlay-block cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  <div className="col-lg-12">
                    <Field
                      name="name"
                      component={Input}
                      placeholder="Text"
                      label="Nama Access Role"
                    />
                  </div>
                </div>

                {/* {role} */}
                {accessRoleFunction()}
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              {BlockOrg() && (
                <button
                  type="submit"
                  onClick={() => handleSubmit()}
                  className="btn btn-primary btn-elevate"
                >
                  Save
                </button>
              )}
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}
